import { Component } from '@angular/core';

import { FilterService } from '../../../Common/Filter/services/abstract-filter.service';
import { MentionSearchService } from '../../../Monitor/Core/services/mention-search.service';

/**
 * One agent opened up: its own left hand panel beside whichever section the route has selected.
 * Mirrors Social's ThemeComponent, which plays the same part for a theme.
 */
@Component({
    selector: 'agpr-agent',
    templateUrl: './agent.component.html',
    styleUrls: ['./agent.component.scss'],
    // The sections below are the monitoring ones, and their filter panel resolves whichever
    // FilterService it can reach - without this it finds an unrelated one and offers its filters.
    // MonitoringComponent does the same for every route under Monitoring.
    providers: [
        {
            provide: FilterService,
            useExisting: MentionSearchService
        }
    ],
    standalone: false
})
export class AgentComponent {}
